/*
 * @Author: showangjing showangjing@didiglobal.com
 * @Date: 2023-03-13 16:17:08
 * @LastEditors: zhuyating zhuyating@didiglobal.com
 * @LastEditTime: 2024-04-26 14:30:15
 * @FilePath: /fe-estrain-customer/src/utils/train-storage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const STORAGE_SUCCESS_INFO = 'es_h5_train_success_info'

export const STORAGE_LIST_SEARCH_QUERY = 'es_h5_train_list_search_query'
export const STORAGE_ORIGINAL_LIST_SEARCH_QUERY = 'es_h5_train_original_list_search_query'
export const STORATE_CONDITION_SEARCH_QUERY = 'es_h5_train_condition_search_query'
export const STORATE_SCRAMBLE_CONDITION_SEARCH_QUERY = 'es_h5_scramble_train_condition_search_query'
export const STORAGE_CURRENT_SELECTED_CITY = 'es_h5_train_current_select_city'

export const STORAGE_DETAIL_SEARCH_QUERY = 'es_h5_train_detail_search_query'

//搜索历史功能已经下掉
export const STORAGE_HISTORY_LIST = 'es_h5_train_history_list'
export const STORAGE_CITY_HISTORY_LIST = 'es_h5_train_city_history_list'

export const STORAGE_TRAVEL_TYPE = 'es_h5_train_travel_type'

export const STORAGE_CHANGE_REASON = 'es_h5_train_change_reason'
export const STORAGE_CHANGE_INFO = 'es_h5_train_change_info'

export const STORAGE_CHANGE_FAILED_INFO = 'es_h5_train_change_failed_info'

export const STORAGE_TRAIN_INFO = 'es_h5_train_train_info'

export const STORAGE_EDIT_CITY_TYPE = 'es_h5_train_edit_city_type'

export const STORAGE_EDIT_CITY_INFO_FOR_ALIWEB = 'train_edit_city_info_for_aliwebview'

export const STORAGE_SELECT_TICKET = 'es_h5_train_select_ticket'

export const STORAGE_ERROR_MSG = 'es_h5_train_error_msg'

export const STORAGE_CURRENT_TRAVEL = 'es_h5_train_current_travel'

export const STORAGE_CURRENT_REFUND_TICKET_ID =
  'es_h5_train_current_refund_ticket_id'

export const STORAGE_CURRENT_CHANGE_TICKET_ID =
  'es_h5_train_current_change_ticket_id'

export const STORAGE_ACTIVED_BUDGET_CENTER = 'es_public_actived_budget_center'

export const STORAGE_SELECT_SEAT_INFO = 'es_h5_train_select_seat_info'

export const STORAGE_CURRENT_SUPPLIER_ID = 'es_h5_train_current_supplier_id'

export const STORAGE_SELECTED_TIME = 'es_h5_train_selected_time';

export const STORAGE_DETAIL_REFRESH_FLAG = 'es_h5_train_detail_refresh_flag'

export const STORAGE_MAKEORDER_LOGIN_TYPE = 'es_h5_train_makeorder_login_type'

export const HOME_SEARCH_CONDITION = 'es_h5_train_home_search_condition'

export const HOME_SELECTED_DATE = 'es_h5_train_home_selected_date'

export const STORAGE_FLIGHTS_QUERY_TC = 'flights_query_from_tc_in_home'

export const HOME_TAB_SELECT = 'h5_home_page_tab_selected'

export const TRANSFER_TAB_TOGGLE = 'es_h5_train_transfer_tab_toggle'

export const SCRAMBLE_ACC_PRE_STATUS = 'train_scramble_acc_pre_status' // 本地加速进行记录

export const SCRAMBLE_SPEED_PRE_STATUS = 'train_scramble_speed_pre_status' // 本地速度档次进行记录

export const SCRAMBLE_PRE_STATUS = 'train_scramble_pre_status' // 抢票状态进行记录

export const NOT_FIRST_SEEN_ACC_PACK = 'train_not_first_seen_acc_pack' // 是否展示加速包new

export const TICKET_RETENTION_POPUP_CD = 'ticket_retention_popup_cd' // 购票挽留弹窗cd

export const TICKET_RETENTION_POPUP_TIMES = 'ticket_retention_popup_times' // 购票挽留自然日内弹窗次数